import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import API from '../services/api';

export default function PrintSchoolReportPage() {
  const [searchParams] = useSearchParams();
  const schoolName     = searchParams.get('school');
  const date           = searchParams.get('date');

  const [records,  setRecords]  = useState([]);
  const [officers, setOfficers] = useState({});
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    API.get('/maintenance').then(async res => {
      let data = res.data;
      if (schoolName) data = data.filter(r => r.school_number === schoolName);
      if (date)       data = data.filter(r => r.opened_date?.slice(0, 10) === date);
      setRecords(data);

      const o   = {};
      const ids = [...new Set(data.flatMap(r => [
        r.opening_officer_id, r.inspection_officer_1_id, r.inspection_officer_2_id,
      ]).filter(Boolean))];
      await Promise.all(ids.map(async oid => {
        try { const r2 = await API.get(`/employees/${oid}`); o[oid] = r2.data; } catch {}
      }));
      setOfficers(o);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [schoolName, date]);

  useEffect(() => {
    if (!loading && records.length > 0) setTimeout(() => window.print(), 600);
  }, [loading, records]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40 }}>පූරණය වෙමින්...</div>;
  if (!records.length) return (
    <div style={{ textAlign: 'center', padding: 40 }}>
      <p>වාර්තා නොමැත</p>
      <p style={{ fontSize: '12pt', marginTop: 10, color: '#666' }}>
        පාසල: {schoolName} | දිනය: {date}
      </p>
      <button onClick={() => window.history.back()}
        style={{ marginTop: 20, background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
        ← ආපසු යන්න
      </button>
    </div>
  );

  const first       = records[0];
  const openOfficer = officers[first.opening_officer_id];
  const inspect1    = officers[first.inspection_officer_1_id];
  const inspect2    = officers[first.inspection_officer_2_id];

  const systemUnits = records.filter(r => r.type === 'system_unit');
  const monitors    = records.filter(r => r.type === 'monitor');
  const others      = records.filter(r => !['system_unit', 'monitor'].includes(r.type));

  const total = (arr) => arr.reduce((s, r) => s + parseFloat(r.estimated_value || 0), 0);
  const fmt   = (n)   => n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const chk   = (c)   => c ? '[√]' : '[ ]';

  const DeviceRows = ({ items, label }) => (
    <>
      <tr>
        <td colSpan="7" style={{ backgroundColor: '#f3f4f6', fontWeight: 'bold', padding: '3px 5px' }}>{label}</td>
      </tr>
      {items.length === 0 ? (
        <tr><td colSpan="7" style={{ textAlign: 'center' }}>{label} නොමැත</td></tr>
      ) : (
        <>
          {items.map((item, i) => (
            <tr key={item.id}>
              <td>{i + 1}</td>
              <td>
                {item.device_name || 'N/A'}
                {item.device_name && item.serial_number ? ' - ' : ''}
                {item.serial_number || ''}
              </td>
              <td>{item.school_assigned_number}</td>
              <td style={{ textAlign: 'center' }}>{chk(item.status === 'fixed')}</td>
              <td style={{ textAlign: 'center' }}>{chk(item.status === 'needs_parts')}</td>
              <td style={{ textAlign: 'center' }}>{chk(item.status === 'unusable')}</td>
              <td style={{ textAlign: 'right' }}>{fmt(parseFloat(item.estimated_value || 0))}</td>
            </tr>
          ))}
          <tr>
            <td colSpan="6" style={{ textAlign: 'right' }}>{label} එකතුව</td>
            <td style={{ textAlign: 'right' }}>{fmt(total(items))}</td>
          </tr>
        </>
      )}
    </>
  );

  return (
    <>
      <style>{`
        @page { size: A4; margin: 1cm; }
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body {
          font-family: "Iskoola Pota", Arial, sans-serif;
          line-height: 1.1;
          font-size: 10pt;
          padding: 10px;
          background: white;
        }
        table { width: 100%; border-collapse: collapse; margin-bottom: 8px; margin-top: 0; }
        th, td { border: 1px solid black; padding: 3px; text-align: left; font-size: 9pt; }
        th { background-color: #f3f4f6; font-weight: bold; }
        p { margin: 3px 0; }
        h3 { margin: 5px 0; line-height: 1.2; }
        .no-print { display: none; }
        .committee-item { margin-bottom: 10px; display: flex; align-items: center; }
        .committee-item::after { content: "........................"; margin-left: 8px; }
        @media screen {
          .no-print { display: flex; gap: 8px; padding: 10px; background: #f3f4f6; margin-bottom: 10px; }
        }
        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .letterhead-container { page-break-inside: avoid; }
        }
      `}</style>

      {/* Screen buttons */}
      <div className="no-print">
        <button onClick={() => window.history.back()}
          style={{ background: '#ef4444', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          ← ආපසු යන්න
        </button>
        <button onClick={() => window.print()}
          style={{ background: '#3b82f6', color: 'white', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>
          🖨️ මුද්‍රණය
        </button>
      </div>

      {/* ── Letterhead ── */}
      <div className="letterhead-container" style={{ width: '100%', position: 'relative', minHeight: 200, marginBottom: 20 }}>

        {/* Left */}
        <div style={{ position: 'absolute', left: 0, top: 0, textAlign: 'left', lineHeight: 1.6, fontSize: '9pt' }}>
          කලාප අධ්‍යාපන අධ්‍යක්ෂ<br/>
          Director of Education {'}'} 091 2258596<br/>
          කාර්යාලය<br/>
          Office {'}'} 091 2256910<br/>
          <span style={{ visibility: 'hidden' }}>Office</span> {'}'} 091 2258696
        </div>

        {/* Center — Logo + Title */}
       <div style={{ 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center', 
  justifyContent: 'center', 
  width: '100%', 
  paddingTop: 10 
}}>
  <img
    src="/images/sri-lanka-emblem.png"
    alt="Sri Lanka Emblem"
    style={{ width: 80, height: 'auto', marginBottom: 8 }}
    onError={e => e.target.style.display = 'none'}
  />
  <div style={{ textAlign: 'center', lineHeight: 1.4, fontSize: '11pt' }}>
    කලාප අධ්‍යාපන කාර්යාලය<br/>
    අම්බලන්ගොඩ<br/>
    Zonal Education Office<br/>
    Ambalangoda.
  </div>
</div>

        {/* Right */}
        <div style={{ position: 'absolute', right: 0, top: 0, textAlign: 'right', lineHeight: 1.6, fontSize: '9pt' }}>
          ෆැක්ස්<br/>
          Fax {'}'} 091 2258596<br/>
          ඊ-මේල්<br/>
          E-mail {'}'} ezoneamb@yahoo.com
        </div>

        {/* Reference line */}
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          borderTop: '1px solid black', borderBottom: '1px solid black',
          marginTop: 10, padding: '3px 0', clear: 'both', width: '100%'
        }}>
          <div style={{ lineHeight: 1.4 }}>මගේ අංකය<br/>My No. {'}'}</div>
          <div style={{ lineHeight: 1.4 }}>ඔබේ අංකය<br/>Your No. {'}'}</div>
          <div style={{ lineHeight: 1.4 }}>දිනය<br/>Date {'}'} ...................</div>
        </div>
      </div>

      {/* ── Body ── */}
      <p>විදුහල්පති,<br/>{first.school_number}</p>
      <p>&nbsp;</p>

      <div style={{ marginBottom: 10 }}>
        <h3>
          <u>{first.opened_date?.slice(0, 10)} දින පැවැත් වු පරිගණක දෘඪාංග අලුත්වැඩියා කිරීමේ වැඩසටහන පිළිබඳ වාර්තාව</u>
        </h3>
        <p style={{ marginTop: 5 }}>
          ඔබ විසින් අප වෙත ඉදිරිපත් කරන ලද ඉල්ලීමට අනුව ඉහත සඳහන් දින {first.school_number},
          හි දී සිදු කරන ලද පරිගණක දෘඩාංග අලුත්වැඩියා කිරීමේ වැඩසටහන පිළිබඳ වාර්තාව මේ සමග ඉදිරිපත් කර ඇත.
        </p>
      </div>

      {/* ── Table ── */}
      <table style={{ marginTop: 10 }}>
        <thead>
          <tr>
            <th rowSpan="2" style={{ verticalAlign: 'middle' }}>අංකය</th>
            <th rowSpan="2" style={{ verticalAlign: 'middle' }}>උපාංගය</th>
            <th rowSpan="2" style={{ verticalAlign: 'middle' }}>පාසල ලබා දුන් අංකය</th>
            <th colSpan="4" style={{ textAlign: 'center' }}>අනාවරණය</th>
          </tr>
          <tr>
            <th>ක්‍රියාත්මකය</th>
            <th>උපාංග යෙදවීමෙන් පසු ක්‍රියාත්මක කළ හැක</th>
            <th>අලුත් වැඩියා කළ නොහැක</th>
            <th>තක්සේරු මිල (Rs.)</th>
          </tr>
        </thead>
        <tbody>
          <DeviceRows items={systemUnits} label="System Units" />
          <DeviceRows items={monitors}    label="Monitors" />
          <DeviceRows items={others}      label="Other" />
          <tr>
            <td colSpan="6" style={{ textAlign: 'right' }}><strong>මුළු එකතුව</strong></td>
            <td style={{ textAlign: 'right' }}>
              <strong>{fmt(total(systemUnits) + total(monitors) + total(others))}</strong>
            </td>
          </tr>
        </tbody>
      </table>

      {/* ── Footer ── */}
      <div style={{ marginTop: 10, lineHeight: 1 }}>
        <p>භාණ්ඩ සමීක්ෂණයක දී මෙම වාර්තාව ඉදිරිපත් කර අලුත්වැඩියා කළ නොහැකි භාණ්ඩ, බඩු වට්ටෝරු
           පොතෙන් ඉවත් කිරීමට කටයුතු කරන්න. මෙම ලේඛනය පාසලේ ගොනු කර තබන්න.</p>

        <div style={{ marginTop: 10 }}>
          <p><strong>දෘඪාංග කමිටු සාමාජික:-</strong></p>
          <div style={{ marginTop: 10 }}>
            {openOfficer && (
              <div className="committee-item">
                1. {openOfficer.nama} - {openOfficer.lipinaya}
              </div>
            )}
            {inspect1 && (
              <div className="committee-item">
                2. {inspect1.nama} - {inspect1.lipinaya}
              </div>
            )}
            {inspect2 && (
              <div className="committee-item">
                3. {inspect2.nama} - {inspect2.lipinaya}
              </div>
            )}
          </div>
        </div>

        {/* Signature */}
        <div style={{ marginTop: 40, borderTop: '1px solid black', width: 200, paddingTop: 5 }}>
          <p style={{ margin: 0 }}>නියෝජ්‍ය/සහකාර අධ්‍යාපන අධ්‍යක්ෂ</p>
          <p style={{ marginTop: 2 }}>(තොරතුරු හා සන්නිවේදන තාක්ෂණ)</p>
        </div>
      </div>
    </>
  );
}